import { formatDate } from '../../../utility/dateUtils';

const MODERATOR_DATE_FORMAT = 'MMM d';

export const getEmployeeAgendaLabel = (label, dateAdded) =>
  label.replace('[DATE]', formatDate(dateAdded, MODERATOR_DATE_FORMAT));
